import { Directive, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { FormViewState } from '@records/records-search/records-details/state';
import { Column } from '@miq/catalog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ComponentRegistryService } from '@controls/renderers/component-registry.service';

/**
 * Binds style visibility and position values whether if a given column is flagged as favorite or not
 */
@UntilDestroy()
@Directive({
  selector: '[miqColumnFavoriteHandler]',
  standalone: false,
})
export class ColumnFavoriteHandlerDirective implements OnInit, OnDestroy {
  @Input() config: Column = null;
  @HostBinding('style.visibility') visibility = '';
  @HostBinding('style.position') position = '';

  constructor(
    private store: Store,
    private componentRegistryService: ComponentRegistryService
  ) {}

  ngOnInit(): void {
    this.initHostBindingVars(this.config);
  }

  private initHostBindingVars(config: Column) {
    const component = this.componentRegistryService.getColumnComponent(config.columnId);
    this.store
      .select(FormViewState.favoriteOptions)
      .pipe(untilDestroyed(this))
      .subscribe(fav => {
        // update attributes on every favorite state change
        const shouldHide = !fav.favorites[config.columnId] && !component?.config?.required;
        this.visibility = fav.showFavorites && shouldHide ? 'hidden' : '';
        this.position = fav.showFavorites && shouldHide ? 'fixed' : '';
      });
  }

  ngOnDestroy(): void {
    // required by untilDestroyed
  }
}
